import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TranslocoModule } from "@ngneat/transloco";
import { AutoLoginAllRoutesGuard } from "angular-auth-oidc-client";

import { NewsListComponent } from "./news/components/news-list/news-list.component";
import { NewsComponent } from "./news/components/news/news.component";
import { NewsModule } from "./news/news.module";

export { NewsComponent } from "./news/components/news/news.component";

export { NEWS_CONFIG } from "./news/services/news.service";
export const NewsPaths = {
    Root: "news",
};

export const NewsRoutes: Routes = [{
    path: "news",
    data: { title: "global.titles.news" },
    canActivate: [AutoLoginAllRoutesGuard],
    children: [{
        path: "",
        component: NewsListComponent,
    }, {
        path: ":newsId",
        data: { autoBreadcrumbsDisabled: true },
        children: [{
            path: "",
            component: NewsComponent,
        }],
    }],
}];

@NgModule({
    imports: [CommonModule, RouterModule.forChild(NewsRoutes), TranslocoModule, NewsModule],
    exports: [NewsModule],
    declarations: [],
    providers: [],
})
export class FeatureNewsModule {}
